<template>
  <div>  
    <v-combobox
      v-model="tabela.selecionados"
      :items="tabela.dados"
      item-text="codigo"
      item-value="id"
      
      outlined
      readonly
      dense
      append-icon="pi pi-search"
      hide-details
      @click="abrirModal"
      @mousedown="abrirModal"
      @mouseup="abrirModal"
    />
    <modal-padrao
      ref="modal-servico-manutencao"
      max-width="80%"
      :titulo="$t('modulos.orcamentos.modais.servico_manutencao.titulo')"
      :titulo-ok="$t('geral.botoes.confirmar')"
      :titulo-cancelar="$t('geral.botoes.cancelar')"
      @ok="closeModal"
    >
      <tabela-padrao-prime-vue
        v-model="tabela.selecionados"
        class="mt-2"
        filtros-com-colunas
        :selecionar-apenas-um="true"
        :colunas="tabela.colunas"
        :dados="tabela.dados"
        :mostrar-acoes="false"
        :quantidade-itens="tabela.quantidadeItens"
        :por-pagina="tabela.porPagina"
        :quantidade-paginas="tabela.quantidadePaginas"
        :pagina="tabela.paginaAtual"
        ajustar-altura-linha
        @paginar="listarRegistros"
        @filtrarGlobal="listarRegistros"
        @filtroGlobal="(v) => (filtroAplicado.filter = v || '')"
      >
        <template v-slot:faixa="{ slotProps }">
          <span
            v-if="
              slotProps.data.amplitudeMinima &&
                slotProps.data.amplitudeMaxima &&
                slotProps.data?.unidadeMedida.nome
            "
          >
            {{
              faixaFormatada(`(${ slotProps.data?.amplitudeMinima + ' a '}
              ${ slotProps.data?.amplitudeMaxima })
              ${slotProps.data?.unidadeMedida?.nome || '' }`)
            }}
          </span>
        </template>
      </tabela-padrao-prime-vue>
    </modal-padrao>
  </div>
</template>
  
  <script>
  import ServicoService from '@/common/services/cadastros/ServicoService';

  export default {
    props: {
      instrumentosIds: {
        type: Array,
        default: () => [],
      },
      localExecucaoId: {
        type: String,
        default: '',
      },
      criterio: {}
    },
    data() {
      return {
        idsJaSelecionados: [],
        filtroAplicado:{},
        tabela: {
          selecionados: [],
          dados: [],
          colunas: [
            {
              value: 'codigo',
              text: this.$t(
                'modulos.orcamentos.modais.servico_manutencao.codigo'
              ),
              sortable: false,
            },
            {
              value: 'nome',
              text: this.$t('modulos.orcamentos.modais.servico_manutencao.nome'),
              sortable: false,
            },
            {
              value: 'faixa',
              text: this.$t('modulos.orcamentos.modais.servico_manutencao.faixa'),
              sortable: false,
            },
            {
              value: 'localExecucao.nome',
              text: this.$t('modulos.orcamentos.modais.servico_manutencao.local'),
              sortable: false,
            },
            {
              value: 'laboratorio.nome',
              text: this.$t(
                'modulos.orcamentos.modais.servico_manutencao.laboratorio'
              ),
              sortable: false,
            },
            {
              value: 'valorServico',
              text: this.$t('modulos.orcamentos.modais.servico_manutencao.valor'),
              sortable: false,
            },
          ],
          quantidadeItens: 0,
          quantidadePaginas: 0,
          paginaAtual: 1,
          porPagina: 10,
        },
        selecionado:{},
        form: {
          participanteContaId: null,
        },
        selectedItem:[]
      }
    },
    watch:{
      'tabela.selecionados'(valor){
        if (!valor) return;
        let criterios = this.$store.getters['criterios/getCriterios'];
        const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);

        if (itemEncontrado) {
          let servicoCalibracao = {
            id: valor.id,
            codigo: valor.codigo
          }
          itemEncontrado.servicoCalibracaoId = valor.id
          itemEncontrado.servicoCalibracao =  servicoCalibracao
          this.selectedItem = servicoCalibracao
          this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: itemEncontrado });
          return 
        }
      },
    },
    mounted(){
      this.setup()
    },
    methods: {
      setup(){
        this.listarRegistros()
        let criterios = this.$store.getters['criterios/getCriterios']
        const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)

        if(itemEncontrado) {
          this.tabela.selecionados = itemEncontrado.servicoCalibracao
        }
      },
      abrirModal: function () {
        this.$refs['modal-servico-manutencao'].abrirModal();
      },
      listarRegistros: function (
        paginaAtual = this.tabela.paginaAtual,
        porPagina = this.tabela.porPagina
      ) {
        let parametros = {
          page: paginaAtual,
          amountPerPage: porPagina,
          ...this.filtroAplicado
        };
        let instrumentosIds = this.instrumentosIds
          .map((id) => {
            return `InstrumentoId=${id}`;
          })
          .join('&');
  
        if (this.localExecucaoId && instrumentosIds?.length == 0) {
          parametros.LocalExecucaoId = this.localExecucaoId;
        }
  
        ServicoService.buscarTipoServico(
          parametros,
          'Manutencao',
          instrumentosIds
        ).then((response) => {
          this.tabela.dados = response.data.items;
          this.tabela.quantidadeItens = response.data.totalItems;
          this.tabela.quantidadePaginas = response.data.totalPages;
        });
      },
      closeModal() {
        this.$refs['modal-servico-manutencao'].fecharModal();
      },
      faixaFormatada: function (value) {
        return String(value).replaceAll('.', ',');
      }
    },
  };
  </script>
  